var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topBar"},[(_vm.img.length)?_c('img',{attrs:{"src":_vm.img,"alt":"Guarani AFV"}}):_c('span',{staticClass:"enterpriseDescription_line_bold"},[_vm._v("Empresa: "+_vm._s(_vm.enterpriseName))])])}
var staticRenderFns = []

export { render, staticRenderFns }